import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '@/context/CartContext';
import { toast } from 'sonner';

// Every public selection enters the same authenticated cart and payment screen.
export function useCartBooking() {
  const cart = useCart();
  const navigate = useNavigate();
  const location = useLocation();
  return async (kind, payload) => {
    if (!cart?.isCustomer) {
      sessionStorage.setItem('sila_pending_add', JSON.stringify({ type: 'booking', kind, payload }));
      toast.info('Accedi o registrati per completare l’acquisto nel carrello');
      navigate(`/cliente/accedi?next=${encodeURIComponent(location.pathname + location.search)}`);
      return false;
    }
    await cart.addBooking(kind, payload);
    cart.openMiniCart();
    toast.success('Aggiunto al carrello. Punti e sconti saranno applicati al pagamento.');
    return true;
  };
}
